import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsMuteAllToggle = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-mute-all-toggle", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsMuteAllToggle;
